import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { UserSettingsService } from './user-settings.service';
import { ScaleViewService } from './scale-view.service';

export const compuweighGuard: CanActivateFn = () => {
    const userSettingsService = inject(UserSettingsService);
    const scaleViewService = inject(ScaleViewService);
    const router = inject(Router);

    if (userSettingsService.isScaleOperator()) {
        return true;
    }

    const cachedSettings = userSettingsService.getUserSettings();
    if (cachedSettings && userSettingsService.isCompuweighEnabledForCurrentTU()) {
        return true;
    }

    const defaultLocCode = cachedSettings?.defaultLocCode ?? '';
    return scaleViewService.resolveCompuweighEnabled(defaultLocCode).pipe(
        map(enabled => {
            userSettingsService.setCompuweighEnabled(enabled);
            return enabled ? true : router.createUrlTree(['/']);
        })
    );
};
